import React, { useEffect, useState } from "react";

import { getUserSettings, updateUserSetting } from "services";

import { useAppType, useCancelAsyncOnUnmount, useTranslation } from "utils";

import { Button, Card, Svg } from "components";

export const TopicSuggestionCard = () => {
  const { t } = useTranslation("courses");

  const appType = useAppType();

  const [completed, setCompleted] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const signal = useCancelAsyncOnUnmount()();

  const handleTopicSelection = (selection) => {
    if (completed) {
      return;
    }

    updateUserSetting({
      item: "selectedCourseSuggestion",
      value: selection,
    }).then(() => {
      setCompleted(true);
      setSelectedTopic(selection);
    });
  };

  useEffect(() => {
    getUserSettings({ signal }).then((res) => {
      if (res.selectedCourseSuggestion) {
        setCompleted(true);
        setSelectedTopic(res.selectedCourseSuggestion);
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Card className="topic-suggestion-card">
      <div className="topic-suggestion-card-container">
        {appType.desktop && <Svg svgName="misc/happy_farm" />}
        {completed ? (
          <div className="topic-suggestion">
            <div>
              <h2>{t("topicSuggestionCard.thankYou")}</h2>
              <p className="thank-you-explainer">{t("topicSuggestionCard.thankYouExplainer")}</p>
            </div>
            <Button type="primary" className="topic-button fake-button">
              {selectedTopic}
            </Button>
          </div>
        ) : (
          <div className="topic-suggestion">
            <p>{t("topicSuggestionCard.headline")}</p>
            <div className="button-container">
              <Button className="topic-button" type="primary" onClick={() => handleTopicSelection(t("topicSuggestionCard.option1"))}>
                {t("topicSuggestionCard.option1")}
              </Button>
              <Button className="topic-button" type="primary" onClick={() => handleTopicSelection(t("topicSuggestionCard.option2"))}>
                {t("topicSuggestionCard.option2")}
              </Button>
              <Button className="topic-button" type="primary" onClick={() => handleTopicSelection(t("topicSuggestionCard.option3"))}>
                {t("topicSuggestionCard.option3")}
              </Button>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};
